import { render, staticRenderFns } from "./UcSuggestCompanyOption2.yaml?vue&type=template&id=333df5f8&component"
import script from "./UcSuggestCompanyOption2.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestCompanyOption2.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports